import { renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["TabsList"], _mergeProps({ "data-slot": "tabs-list" }, $setup.delegatedProps, {
        class: $setup.cn('bg-muted text-muted-foreground inline-flex gap-1.5 flex-wrap pb-1.5 border-b-1', $setup.props.class)
    }), {
        default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3 /* FORWARDED */
    }, 16 /* FULL_PROPS */, ["class"]));
}
